/** Newsletter unsubscribe page (F-106).
 *  Simple, idempotent — never reveals list membership. Prefilled from `?email=`. */
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { NavBar } from "@/components/NavBar";
import { T } from "@/lib/theme";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function NewsletterUnsubscribe() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") || "");
  const [state, setState] = useState({ loading: false, done: false, msg: "" });

  useEffect(() => {
    const q = params.get("email");
    if (q) {
      // Auto-submit when we land with an email in the URL.
      submit(q);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = (e) => {
    const val = typeof e === "string" ? e : email;
    if (!val) return;
    setState({ loading: true, done: false, msg: "" });
    axios.get(`${API_BASE}/free/newsletter/unsubscribe`, { params: { email: val } })
      .then((r) => setState({ loading: false, done: true, msg: r.data.message }))
      .catch(() => setState({ loading: false, done: true,
        msg: "If that email was subscribed, it has now been removed." }));
  };

  return (
    <div data-testid="unsubscribe-page" style={{ background: "#fff", minHeight: "100vh",
      color: T.navy, fontFamily: "'Inter',sans-serif" }}>
      <NavBar dark={false} />
      <div style={{ maxWidth: 520, margin: "80px auto", padding: 32,
        border: `1px solid ${T.border}`, borderRadius: 14 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: T.navy }}>
          Unsubscribe from WaveScore Charts
        </h1>
        <p style={{ margin: "12px 0 22px", color: T.muted, fontSize: 14, lineHeight: 1.6 }}>
          We&apos;ll immediately remove your address from all WaveScorePro marketing lists.
          Transactional mail (account, billing, verification) is not affected.
        </p>
        {!state.done ? (
          <>
            <input data-testid="unsubscribe-email"
              type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              style={{ width: "100%", padding: "12px 14px",
                border: `1px solid ${T.border}`, borderRadius: 8,
                fontSize: 14, fontFamily: "inherit", marginBottom: 12 }} />
            <button data-testid="unsubscribe-submit"
              onClick={() => submit()}
              disabled={state.loading || !email}
              style={{ width: "100%", padding: 12, background: T.navy,
                color: "#fff", border: "none", borderRadius: 8,
                cursor: state.loading ? "wait" : "pointer",
                fontSize: 14, fontWeight: 700, fontFamily: "inherit",
                opacity: state.loading || !email ? 0.6 : 1 }}>
              {state.loading ? "Unsubscribing…" : "Unsubscribe"}
            </button>
          </>
        ) : (
          <div data-testid="unsubscribe-done"
            style={{ padding: 20, background: "#F0FDF4",
              border: `1px solid #BBF7D0`, borderRadius: 10,
              color: "#065F46", fontSize: 14 }}>
            {state.msg}
          </div>
        )}
        <div style={{ marginTop: 22, fontSize: 12, color: T.muted, lineHeight: 1.6 }}>
          Operated by <b style={{ color: T.navy }}>I-Assist Pro Limited</b> ·
          {" "}Accra, Ghana ·{" "}
          <a href="tel:+233208553679" style={{ color: T.navy }}>+233 20 855 3679</a>
        </div>
      </div>
    </div>
  );
}
